import { AxiosError, AxiosResponse } from 'axios';
import { useQuery } from 'react-query';

// Services
import { checkForCGISignature } from '../api';

// Interfaces
import { CgiCollectResult } from '../interfaces/API';
import { CgiProvider } from '../interfaces/CGI';

interface Props {
  cacheKey: string;
  orderRef?: string;
  qrStartToken?: string;
  requestStartedMilliseconds?: number;
  provider: CgiProvider;
  interval: number;
  onSuccess: (data: AxiosResponse<CgiCollectResult>) => void;
  onError: (err: AxiosError) => void;
}

const useCgiPolling = ({
  cacheKey,
  interval,
  orderRef,
  qrStartToken,
  requestStartedMilliseconds,
  provider,
  onSuccess,
  onError,
}: Props) => {
  useQuery(
    [cacheKey],
    () => checkForCGISignature({
      orderRef: orderRef,
      qrStartToken: qrStartToken,
      requestStartedMilliseconds: requestStartedMilliseconds,
      provider: provider
    }).then((response) => response),
    {
      enabled: interval > 0,
      refetchOnReconnect: true,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: 3,
      retryDelay: 3000,
      retryOnMount: false,
      refetchIntervalInBackground: true,
      refetchInterval: interval,
      onSuccess,
      onError,
    }
  );
};

export default useCgiPolling;
